import classNames from "classnames";
import { useStore } from "hooks/use-store";
import { ChevronDown, ChevronUp } from "lucide-react";
import { MutableRefObject, useEffect, useState } from "react";
import { Color } from "utils/theme";
import { Button } from "./button";

interface ScrollButtonsProps {
  containerRef: MutableRefObject<any>;
  dependencies?: any[];
  className?: string | Record<string, boolean>;
}

export const ScrollButtons = ({
  containerRef,
  dependencies = [],
  className,
}: ScrollButtonsProps) => {
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const showScrollButtonsStore = useStore((state) => state.showScrollButtons);

  const checkScrollability = () => {
    if (
      containerRef.current &&
      containerRef.current.scrollHeight > containerRef.current.clientHeight
    ) {
      setShowScrollButtons(true);
    } else {
      setShowScrollButtons(false);
    }
  };

  useEffect(() => {
    // Check scrollability on mount and whenever the ref changes
    checkScrollability();

    if (containerRef.current) {
      window.addEventListener("resize", checkScrollability);
    }

    return () => {
      if (containerRef.current) {
        window.removeEventListener("resize", checkScrollability);
      }
    };
  }, [containerRef?.current, containerRef, ...dependencies]);

  if (!showScrollButtonsStore) return null;

  const scrollUp = (e) => {
    e.stopPropagation();
    if (!containerRef.current) return;
    containerRef.current.scrollTop -= 100;
  };

  const scrollDown = (e) => {
    e.stopPropagation();
    if (!containerRef) return;
    containerRef.current.scrollTop += 100;
  };

  if (!showScrollButtons) return null;

  return (
    <div
      className={classNames(
        "rounded-2xl overflow-hidden shadow-xl z-10 border",
        className
      )}
      style={{
        background: Color.Primary[700],
        borderColor: Color.Primary[600],
      }}
    >
      <Button variant="ghost" onClick={scrollUp} size="icon-lg">
        <ChevronUp className="w-7 h-7" />
      </Button>
      <hr className="border-1" style={{ borderColor: Color.Primary[600] }} />
      <Button variant="ghost" onClick={scrollDown} size="icon-lg">
        <ChevronDown className="w-7 h-7" />
      </Button>
    </div>
  );
};
